module.exports = __webpack_public_path__ + "static/easiest-to-use-2e10599c35037f7accc61be4774caa84.svg";